import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import VideoPlayerYoutube from 'components/Widgets/VideoPlayerYoutube';

import useSize from 'components/Common/Screen/Hooks/useSize';
import Header from './Header';
import Location from './Location';
import Languages from './Languages';
import Experience from './Experience';
import Certifications from './Certifications';
import Availability from './Availability';
import Ratings from './Ratings';

export default function Index({ coach }) {
  const wrapper = useRef(null);
  const size = useSize(wrapper);

  return (
    <Row className="coach-profile mt-4 mt-xxl-5" ref={wrapper}>
      <Col xs={12} className="mb-3">
        <h2>
          {coach.attributes.full_name}
        </h2>
      </Col>

      <Col md="auto" className="mb-5 mb-md-0">
        <div className="side-info">
          <Header coach={coach} />

          <Location coach={coach} />

          <Languages coach={coach} />
        </div>
      </Col>

      <Col className="overflow-hidden ps-sm-4">
        <Row className="mb-5">
          <Col xl={size?.width < 991 ? 12 : 6} className="d-none d-md-block">
            <h6 className="mb-3">
              About Me
            </h6>

            <p className="mb-3">
              {coach.attributes.introduction_text}
            </p>
          </Col>

          {coach.attributes.video_link.length > 0 && (
            <Col xl={size?.width < 991 ? 12 : 6}>
              <VideoPlayerYoutube url={coach.attributes.video_link} />
            </Col>
          )}
        </Row>

        {coach.attributes.description && (
          <Row className="mb-5">
            <Col>
              <blockquote className="blockquote">
                <p className="fst-italic">
                  &ldquo;
                  {coach.attributes.description}
                  &rdquo;
                </p>
              </blockquote>
            </Col>
          </Row>
        )}

        <Experience coach={coach} />

        <Certifications coach={coach} />

        <Availability coach={coach} />

        <Ratings coach={coach} />
      </Col>
    </Row>
  );
}

Index.propTypes = {
  coach: PropTypes.object.isRequired,
};
